import React, { useEffect, useRef } from "react";
import Icon from "./Icon";
import "./AppInfo.css";

// Release wording is copied from the first project's information dialog.
const releases = [
  {
    version: "v4.1 (2026-11-05)",
    lines: ["- Үгийн сүлжээ нэмэгдсэн"],
  },
  {
    version: "v4.0 (2026-10-29)",
    lines: [
      "- Шинэ UI дизайн",
      "- DragDrop засагдсан, Утсанд илүү хялбар болсон",
    ],
  },
  { version: "v3.0 (2026-08-05)", lines: ["- Библийн дүрүүд нэмэгдсэн"] },
  {
    version: "v2.6 (2026-05-14)",
    lines: ["- Захидлын цаг үе нэмэгдсэн", "- DragDrop optimize"],
  },
  {
    version: "v2.5 (2026-02-05)",
    lines: ["- Зургаар бүлэг таах дасгалд тайлбар нэмэгдсэн"],
  },
  {
    version: "v2.4 (2026-01-27)",
    lines: ["- Үйлс номын зургаар бүлэг таах нэмэгдсэн", "- Optimize"],
  },
  {
    version: "v2.3 (2026-01-19)",
    lines: ["- Эш үзүүлэгчдийн цаг үе нэмэгдсэн", "- Optimize"],
  },
  {
    version: "v2.2 (2026-01-12)",
    lines: [
      "- Цаг үеүүдийн дасгал нээгдсэн",
      "- Хаадын цаг үе нэмэгдсэн",
      "- Optimize",
    ],
  },
  {
    version: "v2.1 (2026-01-06)",
    lines: [
      "- Илчлэлтийн зургаар бүлэг таах нэмэгдсэн",
      "- Зургаар бүлэг таах random гарч ирнэ",
      "- Линк засалт",
      "- Optimize",
    ],
  },
  {
    version: "v2.0 (2026-01-05)",
    lines: [
      "- Линк засалт",
      "- Дүрүүд илч 10-р бүлэг хүртэл шинэчлэлт",
      "- Coming soon button",
      "- Хувилбарын түүх",
    ],
  },
  { version: "v1.1 (2025-12-09)", lines: ["- Эшлэл сайжруулалт"] },
  { version: "v1.0 (2025-12-04)", lines: ["- Нээлт"] },
];
// Change application details and release notes in this one component file.
export const APP_INFO = {
  title: "Апп мэдээлэл",
  version: "v4.1",
  updated: "2026-11-05",
  copyright: "Зохиогчийн эрх @MCC",
  website: "https://www.mongol-suvd.mn/",
  websiteLabel: "mongol-suvd.mn",
};

export default function AppInfo({ show, onClose }) {
  const closeRef = useRef(null);
  const callback = useRef(onClose);
  callback.current = onClose;
  useEffect(() => {
    if (!show) return undefined;
    const before = document.activeElement;
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const onKey = (e) => {
      if (e.key === "Escape") callback.current();
      if (e.key === "Tab") {
        const nodes = Array.from(
          document.querySelectorAll(
            ".info-dialog button, .info-dialog a[href]",
          ),
        );
        const first = nodes[0],
          last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last?.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first?.focus();
        }
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = oldOverflow;
      document.removeEventListener("keydown", onKey);
      before?.focus?.();
    };
  }, [show]);
  if (!show) return null;
  return (
    <div
      className="dialog-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="info-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="info-title"
      >
        <div className="info-dialog__header">
          <h2 id="info-title">{APP_INFO.title}</h2>
          <button
            className="icon-button"
            type="button"
            onClick={onClose}
            aria-label="Хаах"
            ref={closeRef}
          >
            <Icon name="close" size={22} />
          </button>
        </div>
        <p>Хувилбар: {APP_INFO.version}</p>
        <p>Шинэчлэгдсэн: {APP_INFO.updated}</p>

        <p>{APP_INFO.copyright}</p>
        <p>
          <a href={APP_INFO.website} target="_blank" rel="noopener noreferrer">
            {APP_INFO.websiteLabel}
          </a>
        </p>
        <h3>-Түүх-</h3>
        <div className="release-history">
          {releases.map((item) => (
            <div key={item.version}>
              <strong>{item.version}</strong>
              {item.lines.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
